// The root of a Mission Control page the shell hosts (B1's Home and Action Center, B3's screen-round cards). It lives
// in the shell, not in a lane's views, so any lane mounts it without importing another lane's screens. It renders
// inside the shell's content slot, which is not a .mc scope (V1 screens share that slot and keep their V1 look), so the page carries .mc itself. Inside a
// McRoot (the shell's) it is a plain .mc box that shares the root's instant, flags and settle signal; on its own it is
// its own McRoot. It draws no chrome. Written without JSX so it is a helper, not a screen module.

import { createElement, type ReactNode } from "react";
import { McRoot, useCaptureSettle, useMc, type Settle } from "@/mc";
import { isCapture } from "./capture";

export function McPage({ children }: { children: ReactNode }) {
  // Outside any McRoot the context answers instant 0 with every flag off; a mounted root has a real instant.
  const inRoot = useMc().now !== 0;
  return inRoot ? createElement("div", { className: "mc" }, children) : createElement(McRoot, null, children);
}

/** html[data-capture]: a frame is being photographed, so nothing polls (capture.ts's one reading of the flag). */
export const isCapturePage = isCapture;

/** Registers a read with the capture settle signal, which stays unsettled until the data arrives. */
export function settled<T>(settle: Settle, work: Promise<T>): Promise<T> {
  settle.pending(work);
  return work;
}

export { useCaptureSettle };
